// Page the Google "preferred source" button sits on; sent as the click event's `placement`.
export enum PreferredSourcePlacement {
  ORDER_SUCCESS = 'order_success',
  BLOG_POST = 'blog_post',
  FAQ = 'faq',
}
